import EnrolmentsAdapter from './base';

export default class AttendanceSurvey extends EnrolmentsAdapter {
  modelNamePlural = 'attendanceSurveys';
}
